import { call, put } from 'redux-saga/effects';

import api from 'api';

import { notifyError, notifySuccess } from 'store/notifications/actions';
import {
    updateUserPersonalisationError,
    updateUserPersonalisationRequest,
    updateUserPersonalisationSuccess,
} from 'store/user/actions';

import sentry from 'services/Sentry/SentryInstance';

import { waitForGetUserPersonalisation } from './helpers';

export function* updateUserPersonalisation({
    payload: { payload, onSuccess },
}: ReturnType<typeof updateUserPersonalisationRequest>) {
    try {
        yield call(api.user.putUserPersonalisation, {
            ...payload,
        });

        yield put(updateUserPersonalisationSuccess());

        yield call(waitForGetUserPersonalisation);
        yield put(notifySuccess({ message: 'message.success.changesSaved' }));

        if (onSuccess) yield call(onSuccess);
    } catch (error: any) {
        yield put(updateUserPersonalisationError());
        yield put(notifyError({ message: 'message.error.changesNotSaved' }));
        sentry.sentrySagaLog(error, 'updateUserPersonalisation');
    }
}
